import { render, staticRenderFns } from "./NewDriver.vue?vue&type=template&id=fabad736&"
import script from "./NewDriver.vue?vue&type=script&lang=js&"
export * from "./NewDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports